const PRIMARY_CONTROL_SELECTOR = '[data-list-item-primary="true"]';
const PANEL_FALLBACK_SELECTOR = [
  '.annotation-layer-add:not(:disabled)',
  '.file-picker-action:not(:disabled)',
  '.panel-collapse-button:not(:disabled)',
].join(',');

export function focusAfterListItemRemoval(item: HTMLElement | null, remove: () => void): void {
  const next = item?.nextElementSibling?.querySelector<HTMLElement>(PRIMARY_CONTROL_SELECTOR);
  const previous =
    item?.previousElementSibling?.querySelector<HTMLElement>(PRIMARY_CONTROL_SELECTOR);
  const panelFallback = item
    ?.closest<HTMLElement>('.layers-panel')
    ?.querySelector<HTMLElement>(PANEL_FALLBACK_SELECTOR);
  const target = next ?? previous ?? panelFallback;

  remove();
  requestAnimationFrame(() => {
    if (target?.isConnected) target.focus();
  });
}
